<div class="phone-dialer" role="region" aria-label="Twilio phone dialer">
  <!-- Left side: Dialer -->
  <div class="dialer-left">
    <header class="pd-header">
      <h2>
        <!-- <div class="phone-icon">📱</div> -->
        Twilio Dialer
      </h2>
      <p class="status" aria-live="polite">{{ callStatus }}</p>
    </header>

    <!-- Phone input + actions -->
    <section class="pd-controls">
      <div class="phone-input-group">
        <label class="input-label" for="phone-input">Phone Number</label>
        <input [attr.guide]="'phone-dialer-inp-phone-input' + '__' + sanitizedUrl" id="phone-input" name="phone" type="tel" placeholder="+1 (555) 123-4567" [(ngModel)]="phoneNumber"
          autocomplete="tel" inputmode="tel" aria-label="Phone number to call" />
      </div>
      <div class="control-buttons">
        <button [attr.guide]="'phone-dialer-btn-initialize-device' + '__' + sanitizedUrl" type="button" class="control-btn btn-init" (click)="initDevice()" aria-label="Initialize device">
          <span>⚙️</span>
          Initialize
        </button>
        <button [attr.guide]="'phone-dialer-btn-call' + '__' + sanitizedUrl" type="button" class="control-btn btn-call" (click)="call()"
          [disabled]="!phoneNumber || phoneNumber.trim().length < 10" aria-label="Call">
          <span>📞</span>
          Call
        </button>
        <button [attr.guide]="'phone-dialer-btn-hang-up' + '__' + sanitizedUrl" type="button" class="control-btn btn-hangup" (click)="hangup()" aria-label="Hang up">
          <span>📵</span>
          Hang Up
        </button>
      </div>
    </section>

    <!-- Dial pad -->
    <section class="pd-keypad" aria-label="Dial pad">
      <h3 class="keypad-title">Dial Pad</h3>
      <div class="keypad-grid">
        <button [attr.guide]="'phone-dialer-btn-1' + '__' + sanitizedUrl" class="keypad-btn" (click)="addDigit('1')">1</button>
        <button [attr.guide]="'phone-dialer-btn-2' + '__' + sanitizedUrl" class="keypad-btn" (click)="addDigit('2')">2</button>
        <button [attr.guide]="'phone-dialer-btn-3' + '__' + sanitizedUrl" class="keypad-btn" (click)="addDigit('3')">3</button>
        <button [attr.guide]="'phone-dialer-btn-4' + '__' + sanitizedUrl" class="keypad-btn" (click)="addDigit('4')">4</button>
        <button [attr.guide]="'phone-dialer-btn-5' + '__' + sanitizedUrl" class="keypad-btn" (click)="addDigit('5')">5</button>
        <button [attr.guide]="'phone-dialer-btn-6' + '__' + sanitizedUrl" class="keypad-btn" (click)="addDigit('6')">6</button>
        <button [attr.guide]="'phone-dialer-btn-7' + '__' + sanitizedUrl" class="keypad-btn" (click)="addDigit('7')">7</button>
        <button [attr.guide]="'phone-dialer-btn-8' + '__' + sanitizedUrl" class="keypad-btn" (click)="addDigit('8')">8</button>
        <button [attr.guide]="'phone-dialer-btn-9' + '__' + sanitizedUrl" class="keypad-btn" (click)="addDigit('9')">9</button>
        <button [attr.guide]="'phone-dialer-btn-10' + '__' + sanitizedUrl" class="keypad-btn" (click)="addDigit('+')">+</button>
        <button [attr.guide]="'phone-dialer-btn-11' + '__' + sanitizedUrl" class="keypad-btn" (click)="addDigit('0')">0</button>
        <button [attr.guide]="'phone-dialer-btn-12' + '__' + sanitizedUrl" class="keypad-btn" (click)="addDigit('#')">#</button>
      </div>
      <div class="keypad-actions">
        <button [attr.guide]="'phone-dialer-btn-backspace' + '__' + sanitizedUrl" class="action-btn" (click)="backspace()" title="Backspace" aria-label="Backspace">
          <span>⌫</span>
          Backspace
        </button>
        <button [attr.guide]="'phone-dialer-btn-clear' + '__' + sanitizedUrl" class="action-btn" (click)="clearNumber()" title="Clear" aria-label="Clear">
          <span>🗑️</span>
          Clear
        </button>
      </div>
    </section>
  </div>

  <!-- Right side: Console log viewer -->
  <div class="logs-right">
    <section class="pd-console" aria-label="Call logs">
      <h3 class="console-title">
        <span>📋</span>
        Activity Logs
      </h3>
      <div class="log-container">
        <ul class="log-list">
          <li class="log-item" *ngFor="let log of logs">{{ log }}</li>
        </ul>
      </div>
    </section>
  </div>
</div>